import React, { useEffect, useState } from "react";
import { menuList } from "../../data/menuList";
import { useGetPageQuery } from "../../redux/services/crmAPI";
import "./menu.scss";
import MenuItem from "./menuItem/MenuItem";

const Menu = () => {
    const [permissionsArr, setPermitionsArr] = useState([]);
    const { data: permissions, refetch: refetchPermissions } = useGetPageQuery("ping");

    useEffect(() => {
        if (permissions) {
            setPermitionsArr(permissions.permissions.map((perm) => perm.permission));
        }
    }, [permissions]);

    useEffect(() => {
        const refetch = async () => {
            await refetchPermissions();
        };

        refetch();
    }, []);

    return (
        <>
            {permissionsArr && (
                <div className="menu">
                    {menuList.map((listItem) => {
                        const isHaveNoOnePermition = listItem.links.every(
                            (link) => !permissionsArr.includes(link.permission)
                        );

                        if (isHaveNoOnePermition && !permissionsArr.includes("all")) {
                            return null;
                        }

                        return (
                            <MenuItem
                                key={listItem.name}
                                name={listItem.name}
                                subMenuItems={listItem.links}
                                permissionsArr={permissionsArr}
                            />
                        );
                    })}
                </div>
            )}
        </>
    );
};

export default Menu;
